import { createStyles, makeStyles } from "@material-ui/core";
import { tokens } from "../../../theme/tokens";

export const useGlobalStyles = makeStyles(
  (theme) =>
    createStyles({
      root: {
        height: "100vh",
        alignItems: "center",
      },
      flexColumn: {
        display: "flex",
        flexDirection: "column",
      },
      flexRow: {
        display: "flex",
        flexDirection: "row",
      },
      flexRowReverse: {
        display: "flex",
        flexDirection: "row-reverse",
      },
      noSelect: {
        WebkitTouchCallout: "none",
        WebkitUserSelect: "none",
        KhtmlUserSelect: "none",
        MozUserSelect: "none",
        MsUserSelect: "none",
        userSelect: "none",
      },
      spaceBetween: {
        display: "flex",
        justifyContent: "space-between",
      },
      center: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignSelf: "center",
      },

      iconButton: {
        marginTop: "auto",
        // backgroundColor: theme.palette.primary.main,
        fontFamily: tokens.type.family,
        fontSize: "1em",
        // color: "#ffffff",
        textTransform: "inherit",
        borderRadius: "25px",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.08)",
        border: `1px solid ${tokens.color.border.default}`,
        textAlign: "center",
        padding: "8px",
        // marginRight: "8px",
        "&:hover": {
          backgroundColor: "#3d3d3d",

          boxShadow: "0px 2px 6px rgba(0,0,0,0.12)",
          border: "1px solid #3d3d3d",
          color: "white",
        },
      },
    }),
  { index: 1 }
);
